import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from '../../store';

import Container from '../../UI/Container';
import Raiting from '../../UI/Raiting';
import AdvantagesSticker from '../../UI/AdvantagesSticker';
import UnfoldingBox from '../../UI/UnfoldingBox';
import Icon from '../../UI/Icon';
import CarouselDetail from '../../UI/CarouselDetail';
import Like from '../../UI/Like';
import BookingPanel from '../../components/BookingPanel';

import bemClassName from '../../utils/bem';

// import image from '../../assets/images/patrick-perkins-iRiVzALa4pI-unsplash.jpg';
import './index.scss';
import { IDetailCatalog } from './interface';
// import { ThunkDispatch } from 'redux-thunk';
import CatalogData from '../../API/CatalodData';
// import iconsList from '../../featuresData.json';
import { getFlagsIcons, getSquare, getRoomsType, formatedType } from '../../utils/catalogUtils';
import MapComponent from '../../components/Map';
import Loading from '../../UI/Loading';
import Modal from '../../UI/Modal';
import Button from '../../UI/Button';
import Breadcrumbs from '../../components/Breadcrumbs';

const catalogDetail = bemClassName('catalog-detail');
interface IDataItem {
  icon?: string;
  text: string;
}
const CatalogDetail = () => {
  const windowWidth = useSelector((state: RootState) => state.window.windowWidth);

  const [detailState, setDetailState] = useState<IDetailCatalog>();
  const [isLoadingDetail, setIsLoadingDetail] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [viewShareModal, setViewShareModal] = useState<boolean>(false);

  const shareModalRef = useRef<HTMLDivElement | null>(null);
  const linkRef = useRef<HTMLParagraphElement>(null);

  const { id } = useParams();

  const openShareModal = () => {
    setViewShareModal(!viewShareModal);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };
  const handleOpenModal = () => {
    setOpen(true);
  };

  const copyToClipboard = () => {
    if (linkRef && linkRef.current) {
      const text = linkRef.current.innerText;
      navigator.clipboard.writeText(text);
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      shareModalRef.current &&
      shareModalRef.current instanceof HTMLElement &&
      !shareModalRef.current.contains(event.target as Node)
    ) {
      setViewShareModal(false);
    }
  };

  useEffect(() => {
    document.title = 'Информация о квартире';
    setIsLoadingDetail(true);

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (id !== undefined) {
      CatalogData.getApartament({ productId: id }).then((resp) => setDetailState(resp));
    }
  }, [id]);

  useEffect(() => {
    if (isLoadingDetail) {
      if (!document.body.hasAttribute('style')) {
        document.body.style.overflow = 'hidden';
      }
    } else if (!isLoadingDetail) {
      if (document.body.hasAttribute('style')) {
        document.body.removeAttribute('style');
      }
    }
  }, [isLoadingDetail]);
  useEffect(() => {
    if (detailState) {
      document.title = `${formatedType(detailState?.rooms)} квартира на
      ${detailState?.address?.name}, ${detailState?.city?.name}`;
      setIsLoadingDetail(false);
    } else {
      setIsLoadingDetail(true);
    }
  }, [detailState]);
  return (
    <Container>
      {detailState && (
        <Breadcrumbs
          city={detailState?.city?.name}
          roomsCrumb={[detailState.rooms]}
          apartamentName={detailState.address?.name}
        />
      )}
      <h1>
        {formatedType(detailState?.rooms)} - {detailState?.address?.name}
      </h1>
      {isLoadingDetail && (
        <div className={catalogDetail('carousel-box')}>
          <div className={catalogDetail('carousel')}>
            <Loading externalClassName={catalogDetail('loading')} />
            <p className={catalogDetail('loading-text')}>Идёт загрузка</p>
          </div>
        </div>
      )}
      <div className={catalogDetail('inner')}>
        <div className={catalogDetail('content')}>
          <div className={catalogDetail('interactive')}>
            {detailState && detailState.reviews && (
              <Raiting
                count={detailState.reviews.avr}
                full
                reviews_count={detailState.reviews.scores}
              />
            )}
            <div className={catalogDetail('buttons-wrap')}>
              {detailState && detailState.bonus !== undefined && (
                <AdvantagesSticker
                  data={[`+${detailState.bonus}% к бонусным баллам`]}
                  // , "Бесконтактное заселение"
                />
              )}
              <div className={catalogDetail('buttons')}>
                <div
                  onClick={openShareModal}
                  ref={shareModalRef}
                  className={catalogDetail('share')}>
                  <Icon iconName="share" externalClassName={catalogDetail('share-icon')} />
                  Поделиться
                  {viewShareModal && (
                    <div className={catalogDetail('share-modal')}>
                      <p ref={linkRef} className={catalogDetail('link')}>
                        {window.location.href}
                      </p>
                      <Button
                        handleExternal={() => copyToClipboard()}
                        text="Скопировать ссылку"
                        externalClassName={catalogDetail('copy')}
                      />
                    </div>
                  )}
                </div>
                {detailState && (
                  <Like id={id ? +id : 0} full externalClassName={catalogDetail('like')} />
                )}
              </div>
            </div>
            {detailState && detailState.photos && (
              <CarouselDetail data={detailState.photos} onClick={() => handleOpenModal()} />
            )}
            {detailState && detailState.photos && isOpen && (
              <Modal open={isOpen} handleClose={handleCloseModal} photosMoodal>
                <CarouselDetail data={detailState.photos} modalOpen />
              </Modal>
            )}
          </div>
          {windowWidth < 1024 && detailState && detailState.price && detailState.id && (
            <BookingPanel
              id={detailState.id}
              price={detailState.price}
              load={(value: boolean) => setIsLoadingDetail(value)}
            />
          )}
          <div className={catalogDetail('text-content')}>
            <div className={catalogDetail('unfolding-list')}>
              <h4 className={catalogDetail('unfolding-text')}>Основная информация</h4>
              <div className={catalogDetail('unfolding-column')}>
                {detailState &&
                  detailState.floor &&
                  detailState.floor_count &&
                  detailState.floor !== 0 &&
                  detailState.floor_count !== 0 && (
                    <UnfoldingBox
                      title="Этаж"
                      data={[
                        {
                          text: `${detailState.floor} этаж из ${
                            detailState && detailState.floor_count
                          }`,
                        },
                      ]}
                    />
                  )}
                {detailState && detailState.view && (
                  <UnfoldingBox
                    title="Вид из окна"
                    data={[
                      {
                        text: `${detailState.view}`,
                      },
                    ]}
                  />
                )}
                {detailState?.parking?.type && (
                  <UnfoldingBox
                    title="Парковка"
                    data={[
                      {
                        text: `${detailState.parking.type}, ${detailState.parking.places} мест`,
                      },
                    ]}
                  />
                )}
              </div>
              <div className={catalogDetail('unfolding-column')}>
                {detailState && detailState.area && detailState.area.total && (
                  <UnfoldingBox
                    title="Общая площадь"
                    data={[
                      {
                        text: `${detailState.area.total} кв.м`,
                      },
                    ]}
                  />
                )}
                {detailState && detailState.area && detailState.area.kitchen && (
                  <UnfoldingBox
                    title="Площадь кухни"
                    data={[
                      {
                        text: `${detailState.area.kitchen} кв.м`,
                      },
                    ]}
                  />
                )}
                {detailState &&
                  detailState.floorheight &&
                  detailState.floorheight !== 0 &&
                  detailState.floorheight !== null && (
                    <UnfoldingBox
                      title="Высота потолков"
                      data={[
                        {
                          text: `${detailState.floorheight && detailState.floorheight} метра`,
                        },
                      ]}
                    />
                  )}
              </div>
              {detailState &&
                getSquare(detailState.beds).length > 0 &&
                detailState &&
                detailState.area &&
                detailState.area.bedrooms !== null && (
                  <div className={catalogDetail('unfolding-column')}>
                    {detailState && getSquare(detailState.beds).length > 0 && (
                      <UnfoldingBox title="Спальные места" data={getSquare(detailState.beds)} />
                    )}
                    {detailState &&
                      detailState.area &&
                      detailState.area.bedrooms !== null &&
                      detailState.area.bedrooms !== 0 && (
                        <UnfoldingBox
                          title="Изолированные спальни"
                          data={[{ text: `${detailState.area.bedrooms} штуки` }]}
                        />
                      )}
                    {detailState && detailState.area && detailState.area.type && (
                      <UnfoldingBox
                        title="Тип комнат"
                        data={[
                          {
                            text: `${getRoomsType(detailState.area.type, detailState.rooms)}`,
                          },
                        ]}
                      />
                    )}
                  </div>
                )}
            </div>
            {detailState &&
              detailState.coords &&
              detailState.coords.lon &&
              detailState.coords.lat && (
                <MapComponent
                  externalClassName={catalogDetail('room-mark')}
                  zoomMap={17}
                  dataRoom={detailState}
                  CenterCoordsValue={[detailState.coords.lon, detailState.coords.lat]}
                />
              )}
            <div className={catalogDetail('unfolding-list')}>
              <h4 className={catalogDetail('unfolding-text')}>Правила проживания и размещения</h4>
              {detailState && detailState.rules && detailState.rules.checkIn !== undefined && (
                <div className={catalogDetail('unfolding-column')}>
                  <UnfoldingBox
                    title="Заезд"
                    data={[{ text: `после ${detailState.rules.checkIn}` }]}
                  />
                </div>
              )}
              {detailState && detailState.rules && detailState.rules.checkOut !== undefined && (
                <div className={catalogDetail('unfolding-column')}>
                  <UnfoldingBox
                    title="Отъезд"
                    data={[{ text: `до ${detailState.rules.checkOut}` }]}
                  />
                </div>
              )}
              {detailState && detailState.rules && detailState.rules.duration !== undefined && (
                <div className={catalogDetail('unfolding-column')}>
                  <UnfoldingBox
                    title="Минимальный срок проживания"
                    data={[{ text: `от ${detailState.rules.duration} суток` }]}
                  />
                </div>
              )}
              <ul className={catalogDetail('unfolding-text')}>
                <li>можно с детьми любого возраста</li>
                <li>курение запрещено</li>
                <li>нельзя с питомцами</li>
                <li>без вечеринок и мероприятий</li>
                <li>
                  <a target="_blank" href="/services#agreement">
                    полные правила проживания
                  </a>
                </li>
              </ul>
            </div>
            {detailState && detailState.description && detailState.description !== '' && (
              <div className={catalogDetail('unfolding-list')}>
                <h4 className={catalogDetail('unfolding-text')}>Описание</h4>
                <p className={catalogDetail('unfolding-text')}>{detailState.description}</p>
              </div>
            )}
            <div className={catalogDetail('unfolding-list')}>
              <h4 className={catalogDetail('unfolding-text')}>Удобства</h4>
              <div className={catalogDetail('unfolding-column')}>
                {detailState &&
                  detailState.flags &&
                  getFlagsIcons(detailState.flags, 'equipment').length > 0 && (
                    <UnfoldingBox
                      title="Оснащение"
                      data={getFlagsIcons(detailState.flags, 'equipment') as Array<IDataItem>}
                    />
                  )}
                {/* {detailState && detailState.features && (
                  <UnfoldingBox
                    title="Оснащение"
                    data={getIconsType(detailState.features, "equipment")}
                  />
                )} */}
                {/* {detailState && detailState.features && (
                  <UnfoldingBox
                    title="Досуг и инфраструктура в пределах 10 минут ходьбы"
                    data={getIconsType(detailState.features, "accessibility")}
                  />
                )} */}
                {detailState &&
                  detailState.flags &&
                  getFlagsIcons(detailState.flags, 'forKids').length > 0 && (
                    <UnfoldingBox
                      title="Для детей"
                      data={getFlagsIcons(detailState.flags, 'forKids') as Array<IDataItem>}
                    />
                  )}
              </div>
              <div className={catalogDetail('unfolding-column')}>
                {/* {detailState && detailState.features && (
                  <UnfoldingBox
                    title="Кухня"
                    data={getIconsType(detailState.features, "kitchen")}
                  />
                )} */}
                {detailState &&
                  detailState.flags &&
                  getFlagsIcons(detailState.flags, 'kitchen').length > 0 && (
                    <UnfoldingBox
                      title="Кухня"
                      data={getFlagsIcons(detailState.flags, 'kitchen') as Array<IDataItem>}
                    />
                  )}
                {/* {detailState && detailState.features && (
                  <UnfoldingBox
                    title="Для отдыха"
                    data={getIconsType(detailState.features, "rest")}
                  />
                )} */}
                {detailState &&
                  detailState.flags &&
                  getFlagsIcons(detailState.flags, 'rest').length > 0 && (
                    <UnfoldingBox
                      title="Для отдыха"
                      data={getFlagsIcons(detailState.flags, 'rest') as Array<IDataItem>}
                    />
                  )}
              </div>
              <div className={catalogDetail('unfolding-column')}>
                {/* {detailState && detailState.features && (
                  <UnfoldingBox
                    title="Ванная комната"
                    data={getIconsType(detailState.features, "bathroom")}
                  />
                )} */}
                {detailState &&
                  detailState.flags &&
                  getFlagsIcons(detailState.flags, 'accessibility').length > 0 && (
                    <UnfoldingBox
                      title="Досуг и инфраструктура в пределах 10 минут ходьбы"
                      data={getFlagsIcons(detailState.flags, 'accessibility') as Array<IDataItem>}
                    />
                  )}
                {detailState &&
                  detailState.flags &&
                  getFlagsIcons(detailState.flags, 'bathroom').length > 0 && (
                    <UnfoldingBox
                      title="Ванная комната"
                      data={getFlagsIcons(detailState.flags, 'bathroom') as Array<IDataItem>}
                    />
                  )}
                {/* {detailState && detailState.features && (
                  <UnfoldingBox
                    title="Для детей"
                    data={getIconsType(detailState.features, "forKids")}
                  />
                )} */}
              </div>
            </div>
          </div>
        </div>
        {windowWidth >= 1024 && detailState && (
          <div className={catalogDetail('right-side')}>
            <BookingPanel
              id={detailState.id}
              cityName={detailState?.city?.name}
              address={detailState?.address?.name}
              side
              price={detailState.price}
              load={(value: boolean) => setIsLoadingDetail(value)}
              deposit={detailState.deposit}
            />
          </div>
        )}
      </div>
    </Container>
  );
};

export default CatalogDetail;
